import { Component, inject, signal } from '@angular/core';
import { LanguageService, SupportedLocale } from '../../../services/language.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-lite-navbar',
  imports: [RouterLink],
  templateUrl: './lite-navbar.html',
  styleUrl: './lite-navbar.css',
})
export class LiteNavbar {
  private langService = inject(LanguageService);

  currentLocale = this.langService.getCurrentLocale();
  isMenuOpen = signal(false);

  toggleMenu(): void {
    this.isMenuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  switchLanguage(locale: SupportedLocale): void {
    this.langService.switchLanguage(locale);
  }
}
